import { render, staticRenderFns } from "./PaymentType.vue?vue&type=template&id=36135202&scoped=true&"
import script from "./PaymentType.vue?vue&type=script&lang=js&"
export * from "./PaymentType.vue?vue&type=script&lang=js&"
import style0 from "./PaymentType.vue?vue&type=style&index=0&id=36135202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36135202",
  null
  
)

export default component.exports